<template>
    <div class="main">
        <div class="body-content">
            <div class="controls">
                <div class="search-container">
                    <input v-model="searchQuery" placeholder="Search..." />
                    <i class="fas fa-search search-icon"></i>
                </div>
                <h1 class="title">Dockout Bookingno</h1>
                <div class="actions">
                    <div class="tooltip-container" @mouseleave="hideTooltip">
                        <button class="add-button" @click="openAddModal" title="Add Booking no"
                            :disabled="selectedBookingNo || isSubmitting">
                            <i class="fas fa-plus"></i>
                            <div v-if="showAddTooltip" class="tooltip">Add Booking no</div>
                        </button>
                    </div>
                </div>
            </div>
            <div class="table-container">
                <table class="transaction-table table-design">
                    <thead>
                        <tr>
                            <th>
                                <span>Sl. No</span>
                            </th>
                            <th>
                                <span>Applicant</span>
                            </th>
                            <th>
                                <span>Account</span>
                            </th>
                            <th>
                                <span>Vessel</span>
                            </th>
                            <th>
                                <span>Voyage</span>
                            </th>
                            <th>
                                <span>Location</span>
                            </th>
                            <th>
                                <span>Movement</span>
                            </th>
                            <th>
                                <span>Booking No</span>
                            </th>
                            <th>
                                <span>Container Type</span>
                            </th>
                            <th>
                                <span>Action</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in bookingnos" :key="index">
                            <td>
                                <span>{{ index + 1 }}</span>
                            </td>
                            <td>
                                <span> {{ item.applicantname }}</span>
                            </td>
                            <td>
                                <span> {{ item.accountname }}</span>
                            </td>
                            <td>
                                <span> {{ item.vessname }}</span>
                            </td>
                            <td>
                                <span> {{ item.voyname }}</span>
                            </td>
                            <td>
                                <span> {{ item.locname }}</span>
                            </td>
                            <td>
                                <span> {{ item.movname }}</span>
                            </td>
                            <td>
                                <span> {{ item.bookingno }}</span>
                            </td>
                            <td>
                                <span> {{ item.conttype }}</span>
                            </td>
                            <th>
                                <button @click="editBooking(item)" class="edit-button" :disabled="isSubmitting"><i
                                        class="fas fa-edit"></i></button>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="isAddModalVisible" class="edit-overlay">
            <div class="edit-overlay-content">
                <span class="close-btn" @click="closeModal">&times;</span>
                <h2><label class="text-h6">{{ isEditing ? 'Edit Booking no' : 'Add Booking no' }}</label></h2>
                <div class="form-row">
                    <label for="applicant">Applicant:</label>
                    <v-select v-model="record.applicant" :options="applicants" label="applicantname" :clearable="false"
                        :reduce="applicants => applicants.applicantid" placeholder="Select Applicant" selectOnTab="True"
                        class="field-width" />

                    <label for="account">Account:</label>
                    <v-select v-model="record.account" :options="accounts" label="accountname" :clearable="false"
                        :reduce="accounts => accounts.accountid" placeholder="Select Account" selectOnTab="True"
                        class="field-width" />
                </div>
                <div class="form-row">
                    <label for="vessel">Vessel:</label>
                    <v-select v-model="record.vessel" :clearable="false" :options="vessel" label="Name"
                        :reduce="vessel => vessel.Vesselid" placeholder="Select Vessel" selectOnTab="True"
                        class="field-width" />

                    <label for="voyage">Voyage:</label>
                    <v-select v-model="record.voyage" :clearable="false" :options="voyage" label="Name"
                        :reduce="voyage => voyage.Voyageid" placeholder="Select Voyage" selectOnTab="True"
                        class="field-width" />
                </div>
                <div class="form-row">
                    <label for="location">Location:</label>
                    <v-select v-model="record.location" :clearable="false" :options="location" label="Name"
                        :reduce="location => location.locationid" placeholder="Select Location" selectOnTab="True"
                        class="field-width" />

                    <label for="bookingno">Booking No:</label>
                    <input type="text" v-model="record.bookingno" class="field-width" placeholder="Enter Booking No" />
                </div>
                <div class="form-row">
                    <label for="movement">Movement:</label>
                    <v-select v-model="record.movementid" :options="movements" label="Name" :clearable="false"
                        :reduce="movement => movement.Movid" placeholder="Select Movement" selectOnTab="True"
                        class="field-width" />
                    <label for="location">Container Type:</label>
                    <v-select v-model="record.conttype" :clearable="false" :options="conttype" label="typetext"
                        :reduce="conttype => conttype.typecode" placeholder="Select Type" selectOnTab="True"
                        class="field-width" />
                </div>
                <!-- Save and Cancel buttons -->
                <div class="form-buttons">
                    <button type="submit" @click="save" class="save-button" :disabled="isSubmitting">Save</button>
                    <button type="button" class="cancel-button" @click="isAddModalVisible = false" :disabled="isSubmitting">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
export default {
    components: {
        VSelect,
    },
    data() {
        return {
            vessel: JSON.parse(localStorage.getItem('vessel')) || [],
            voyage: JSON.parse(localStorage.getItem('voyage')) || [],
            applicants: JSON.parse(localStorage.getItem('applicants')) || [],
            accounts: JSON.parse(localStorage.getItem('accounts')) || [],
            location: JSON.parse(localStorage.getItem('locations')) || [],
            movements: JSON.parse(localStorage.getItem('movements')) || [],
            isAddModalVisible: false, // Control visibility of the modal
            DEFAULT_RECORD: { autoid: 0, applicant: 0, account: 0, vessel: 0, voyage: 0, location: 0, bookingno: '', conttype: '', movementid: 0 },
            bookingnos: [],
            conttype: [],
            isEditing: false,
            isSubmitting: false,
            record: {},
        }
    },
    created() {
        this.fetchBookingnos();
        this.fetchContainerType();
    },
    methods: {
        async fetchContainerType() {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        accept: 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                };
                const response = await axios.get('/container_type', config);
                this.conttype = response.data[2];
            } catch (error) {
                console.error('Error fetching container types:', error);
                useToast().error('Error fetching container types.');
            }
        },
        async fetchBookingnos() {
            const token = localStorage.getItem('access_token');
            if (!token) {
                useToast().error('Authentication token not found.');
                return;
            }
            try {
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };

                const response = await axios.get('/bookingno_list', config);
                //console.log('Bookingnos response:', response.data);
                this.bookingnos = response.data[2];
            } catch (error) {
                console.error('Error fetching booking list:', error);
                useToast().error('Error fetching booking list.');
            }
        },
        async save() {
            if (this.isSubmitting) return;
            
            // Basic validation
            if (!this.record.applicant || !this.record.account || !this.record.vessel || 
                !this.record.voyage || !this.record.location || !this.record.bookingno || 
                !this.record.conttype || !this.record.movementid) {
                useToast().error('Please fill all required fields.');
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const data = new FormData();
                const transdt = JSON.stringify(this.record)
                //console.log(this.record)
                //console.log(transdt)
                data.append('transaction', transdt)
                const response = await axios.post('/save_bookingno', data, config);
                if (response.data[0] === 0) {
                    if (this.isEditing) {
                        useToast().error(response.data[1] || 'Error updating booking no');
                    } else {
                        useToast().error(response.data[1] || 'Error adding booking no');
                    }
                } else if (response.data[0] === 1) {
                    if (this.isEditing) {
                        useToast().success('Booking no updated successfully');
                        this.isAddModalVisible = false
                    } else {
                        useToast().success('Booking no added successfully');
                        this.isAddModalVisible = false
                    }
                    this.fetchBookingnos();
                }
            } catch (error) {
                console.error('Error saving booking:', error);
                useToast().error(error.response?.data?.message || 'Error saving booking.');
            } finally {
                this.isSubmitting = false;
            }
        },
        openAddModal() {
            if (this.isSubmitting) return;
            this.isAddModalVisible = true; // Show the modal
            this.isEditing = false; // Set to add mode
            this.record = { ...this.DEFAULT_RECORD }; // Reset the record to default
        },
        editBooking(booking) {
            if (this.isSubmitting) return;
            this.isAddModalVisible = true; // Show the modal
            this.isEditing = true; // Set editing mode
            //console.log('Editing booking:', booking);
            this.record = {
                autoid: booking.autoid,
                applicant: booking.applicant,
                account: booking.account,
                vessel: booking.vessel,
                voyage: booking.voyage,
                location: booking.location,
                bookingno: booking.bookingno,
                conttype: booking.conttype,
                movementid: booking.movementid
            }; // Set the record to the selected booking
        },
        closeModal() {
            this.isAddModalVisible = false; // Hide the modal
        },
    }
}
</script>
<style scoped>
.field-width {
    width: 250px;
}
.column-item {
  display: flex;
  align-items: center;
  margin: 4px 0;
}

input[type="checkbox"] {
  margin-right: 8px;
}
.save-button,
.cancel-button {
    font-size: 18px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    color: white;
}

.save-button:disabled,
.cancel-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}

.edit-button:disabled {
    color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}

.add-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}

.save-button {
    background-color: #28a745;
}

.cancel-button {
    background-color: red;
}

.table-container {
    /*max-height: 100%;*/
    overflow: auto;
    border: 1px solid #ddd;
    border-radius: 10px;
}

.transaction-table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
}

.transaction-table th,
.transaction-table td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.transaction-table th {
    background-color: #f2f2f2;
    font-weight: bold;
}

.transaction-table th .filter-icon {
    cursor: pointer;
    margin-left: 5px;
}

.upload-content-tile h1 {
    color: #343a40;
    font-size: 28px;
    margin-bottom: 25px;
    margin-left: 25px;
}

.form-row {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.form-row label {
    font-weight: bold;
    margin-right: 10px;
    width: 100px;
    /* Adjust width as needed */
    color: #495057;
}

select,
v-select {
    width: 150px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
}

.custom-file-input {
    width: 100%;
    max-width: 300px;
    /* Adjust the width to match the select box */
    padding: 8px;
    border: 2px solid #ced4da;
    border-radius: 8px;
    font-size: 16px;
    color: #495057;
    background-color: #fff;
}

.form-actions {
    margin-top: 30px;
}

.form-actions button {
    padding: 12px 25px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 18px;
    transition: background-color 0.3s ease;
}

.form-actions button:hover {
    background-color: #0056b3;
}

/* Overlay container */
.edit-overlay {
    position: fixed;
    /* Ensures the overlay stays above all other content */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    /* Enables scrolling if the content exceeds viewport height */
    z-index: 9999;
    /* Ensures it appears above all other content */
}

/* Overlay content */
.edit-overlay-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 60%;
    /* Adjusted width for better fit */
    /*max-width: 1000px;*/
    /* Adjusted max-width */
    max-height: 90vh;
    /* Limits the height to prevent overflow */
    overflow-y: auto;
    /* Enables vertical scrolling within the content */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-top: 50px;
    /* Adds margin from the top */
}

.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    cursor: pointer;
    color: #333;
}
</style>